import React, { useEffect, useState } from "react";
import Index from "./Pages/Index";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Favicon from "react-favicon";
// import { assets } from "./assets/Assets";
import axiosInstance from "./axiosInstance";
import MyComponent from './components/MyComponent';


function App() {

  const [settings, setSettings] = useState([]);
  const assetsUrl = import.meta.env.VITE_ASSETS_URL;
  // Fetch Settings and Social Media
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("WebApi/Dashboard.php");
        setSettings(response.data.settings || []);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchData();
  }, []);

  const getSettingValue = (slug) => {
    const setting = settings.find((item) => item.slug === slug);
    return setting ? setting.value : "";
  };


  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      caption: (Fancybox, slide) => {
        const caption = slide.caption || "";
        return `${caption}`;
      },
    });
  }, []);

  return (
    <>
      <MyComponent />
      <Favicon url={assetsUrl + getSettingValue("fav-icon")} />
      <Index></Index>
    </>
  )
}

export default App;